module.exports = __webpack_public_path__ + "static/media/kushner-witkoff.0f814a92.jpg";